<template>
    <div>
        <van-field
            readonly
            clickable
            :class="vClass"
            :value="showValue"
            placeholder="所在地区"
            @click="setHidden(false)"
        >
            <van-icon name="arrow" slot="right-icon"/>
        </van-field>
        <van-popup v-model="isShow" position="bottom" @opened="opened">
            <van-picker
                ref="picker"
                value-key="name"
                show-toolbar
                :columns="columns"
                @cancel="onCancel"
                @confirm="onConfirm"
                @change="onChange"
            />
        </van-popup>
    </div>
</template>
<script>
export default {
    model: {
        prop: "value",
        event: "updateValue"
    },
    props: {
        value: null,
        // 文本组件样式
        vClass: null
    },
    data() {
        return {
            // 显示文字
            showValue: null,
            // 选中项
            selectValues: null,
            // 是否显示弹出层
            isShow: false
        };
    },
    computed: {
        // 省市县数据
        chinaAddress() {
            return this.$store.state.chinaAddress;
        },
        // 级联配置
        columns() {
            return [
                {
                    values: this.chinaAddress
                },
                { defaultIndex: 1 },
                { defaultIndex: 2 }
            ];
        }
    },
    watch: {
        value(v) {
            this.setValue(v);
        }
    },
    methods: {
        // 选择层弹出时
        opened() {
            const me = this,
                picker = me.$refs.picker;
            // 如果没有选中值
            // 通常只有初始化是才没有选中值
            if (!me.selectValues) {
                const value = me.value;
                // 如果设置了初始化值
                if (value && value.length) {
                    const list = [];
                    // 获取省市县数据
                    let address = me.chinaAddress;
                    // 遍历数据设置选中值
                    value.forEach((item, index) => {
                        const one = address.find(rec => {
                            return rec.name == item.name;
                        });
                        list.push(one);
                        address = one.children;
                    });
                    // 设置选中值
                    me.selectValues = list;
                    // 设置弹层选中值
                    me.setValues(list);
                } else {
                    // 如果没有设置初始化值，默认选中处理
                    me.onChange(picker, picker.getValues(), 0);
                }
            }
        },
        // 显示/隐藏弹出层
        setHidden(v) {
            this.isShow = !v;
        },
        // 点击确定按钮时
        onConfirm(v) {
            const me = this;
            // 隐藏弹出层
            me.setHidden(true);
            // 设置选中值
            me.selectValues = v;
            // 更新value
            me.$emit("updateValue", v);
        },
        // 点击取消按钮时
        onCancel() {
            // 重置弹层选中值
            this.setValues(this.selectValues);
            // 隐藏弹出层
            this.setHidden(true);
        },
        // 值改变时设置选中值
        setValue(data) {
            const list = [];
            // 遍历并设置选中值
            data.forEach(item => {
                list.push(item.name);
            });
            this.showValue = list.join("");
        },
        // 设置弹层选中值
        setValues(values) {
            if (values) {
                const me = this,
                    picker = me.$refs.picker,
                    list = [];
                // 循环遍历设置当前选中项
                values.forEach((item, index) => {
                    // 获取并设置每个选项的可选列表
                    picker.setColumnValues(index + 1, item.children);
                    list.push(item.name);
                });
                // 设置弹层选中值
                picker.setValues(list);
            }
        },
        // 选项发生改变时
        onChange(picker, values, index) {
            // 获取选项长度
            const length = values.length - 1;
            // 当前改变的不是最后一项时才继续处理
            if (index < length) {
                console.log("onChange");
                // 获取下一级可选值
                const data = values[index].children;
                   console.log(index)
                   // 设置下一级可选列表
                picker.setColumnValues(index + 1, data);
                console.log(index)
                // 如果下一级不是最后一项
                if (index < length - 1) {
                    console.log("onSelectNext");
                    // 设置下一级的默认值
                    picker.setColumnValue(index + 1, data[0]);
                    // 自调用循环处理
                    this.onChange(picker, picker.getValues(), index + 1);
                }
            }
        }
    },
    created: function() {
        this.$store.dispatch("chinaAddress");
    }
};
</script>
<style lang="scss" scoped>
</style>
